import axiosClientNotLogin from "./axiosClientNotLogin";
import axiosClientNotATL from "./axiosClientNotATL";

const PREFIX_URL = "client";

const clientApi = {
    getInfoHsm: (params) => {
        const url = `${PREFIX_URL}/getInfoHsm`;
        return axiosClientNotLogin.post(url, params);
    },
    getCaptcha: (params) => {
        const url = `${PREFIX_URL}/get-captcha`;
        return axiosClientNotLogin.get(url, { params });
    },
    infoFileSoftware: (params) => {
        const url = `${PREFIX_URL}/quan-ly-phan-mem/infoFile`;
        return axiosClientNotATL.get(url, { params });
    },
    getDate: (params) => {
        const url = `${PREFIX_URL}/get-date`;
        return axiosClientNotATL.get(url, { params });
    },
    verifyOtp: (params) => {
        const url = `${PREFIX_URL}/verifyOtp`;
        return axiosClientNotLogin.post(url, params);
    },
}

export default clientApi;
